import React from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';
import styles from './SettingsTile.module.scss';

interface SettingsTileProps {
  id: string;
  className?: string | null;
  onClick?: () => void;
  tts?: string | null;
  children: React.ReactNode;
}

const SettingsTile = ({
  id,
  onClick = () => {},
  tts = '',
  children,
  className = null,
}: SettingsTileProps) => (
  <Selectable
    focusId={`setting-item-${id}`}
    className={className}
    ttsText={tts}
    onSelect={onClick}
    render={({ hasFocus }: { hasFocus: boolean }) => (
      <div
        data-testid="settings-tile"
        className={classNames(
          styles.tile,
          hasFocus ? styles.focused : styles.unfocused,
        )}
      >
        <button
          type="button"
          onClick={onClick}
          className={classNames('w-100 h-100', styles.button)}
        >
          <div className={classNames('w-100 h-100', styles.imageOverlay)} />
          <div
            className={classNames(
              'w-100 h-100',
              'd-flex flex-column align-items-center justify-content-center',
              styles.content,
            )}
          >
            {children}
          </div>
        </button>
      </div>
    )}
  />
);

export default React.memo(SettingsTile);
